import { Help } from '@mui/icons-material';
import { MenuItem, TextField } from '@mui/material';
import { get, sortBy } from 'lodash';
import React from 'react';
import MarkdownRenderer from 'src/components/ui-component/markdown-renderer/MarkdownRenderer';
import { MUIFieldProps } from '../../../../../lib/types/types';
import { enumT } from '../../../../../utils/helper';
import MUIToolTip from '../../../mui-tooltip/MUIToolTip';

// const ITEM_HEIGHT = 120;
// const ITEM_PADDING_TOP = 20;
const MenuProps = {
	PaperProps: {
		style: {
			maxHeight: '30rem',
			width: 250,
		},
	},
};

const MUISelectField: React.FC<MUIFieldProps> = (props) => {
	const { label, tooltip, fieldValue, updateFieldValue, isDisabled, sortAlphabetically = true, error, errorMessage, ...restProps } = props;
	let options = get(props, 'options', []).length > 0 ? get(props, 'options', []) : get(props, 'enum', []);
	const enumsLastPlace = get(props, 'enumsLastPlace', []);

	// console.log(' options ', options);
	// if (sortAlphabetically) options.sort();

	if (sortAlphabetically && options.length) {
		if (typeof options[0] === 'string') {
			const filtered = options.filter((item: string) => !enumsLastPlace.includes(item));
			const sorted = sortBy(filtered, (item: any) => enumT(item).toLocaleLowerCase('de'));
			const lastPlace = enumsLastPlace.filter((item: string) => options.includes(item));
			options = [...sorted, ...lastPlace];
		} else if (typeof options[0] === 'object') {
			options = sortBy(options, (item: any) => get(item, 'label', '').toLocaleLowerCase('de'));
		}
	}

	return (
		<TextField
			select
			label={
				tooltip ?
					<>
						<>{label}</>
						<MUIToolTip title={tooltip}>
							{' '}
							<Help fontSize='small' color='primary' sx={{ ml: '5px' }} />{' '}
						</MUIToolTip>
					</>
				:	<>{label}</>
			}
			value={
				typeof fieldValue === 'object' ?
					get(props, 'options', []).length > 0 ?
						fieldValue.id
					:	''
				:	fieldValue
			}
			onChange={updateFieldValue}
			disabled={isDisabled}
			error={error}
			helperText={errorMessage}
			fullWidth
			SelectProps={{
				MenuProps,
				displayEmpty: true,
				renderValue: (selected: any) => {
					if (!selected || selected === '') {
						return <em>{get(props, 'placeholder', 'Bitte auswählen')}</em>;
					}

					// Wenn options ein Array von Objekten ist (Variante 1)
					const selectedOption = options.find((opt: any) => (typeof opt === 'object' ? opt.value === selected : opt === selected));

					if (typeof selectedOption === 'object') {
						return selectedOption.label;
					}
					// Wenn options ein Array von Strings ist (Variante 2)
					return enumT(selected);
				},
			}}
			{...restProps}
		>
			{options.map((ele: any, i: number) => {
				if (get(ele, 'label')) {
					return (
						<MenuItem key={i} value={get(ele, 'value')} sx={{ whiteSpace: 'normal' }}>
							<MarkdownRenderer markdown={get(ele, 'label')} />
							{/* {get(ele, 'label')} */}
						</MenuItem>
					);
				} else {
					return (
						<MenuItem key={i} value={ele} sx={{ whiteSpace: 'normal' }}>
							<MarkdownRenderer markdown={enumT(ele)} />
							{/* {enumT(ele)} */}
						</MenuItem>
					);
				}
			})}
		</TextField>
	);
};

export default MUISelectField;
